import { createClient } from '@supabase/supabase-js';

// Debugging: log environment variables
//console.log('Supabase URL:', process.env.VUE_APP_SUPABASE_URL);
//console.log('Supabase Key:', process.env.VUE_APP_SUPABASE_ANON_KEY);

const supabaseUrl = process.env.VUE_APP_SUPABASE_URL;
const supabaseAnonKey = process.env.VUE_APP_SUPABASE_ANON_KEY;

export const supabase = createClient(supabaseUrl, supabaseAnonKey);
